module.exports = __webpack_public_path__ + "static/media/ag-products8.fab1017b.jpg";